/**
 * Church 도메인 Zod 스키마
 */
import { idSchema } from './common.js';
import { z } from 'zod';
/**
 * 본당 생성 입력 스키마
 */
export const createChurchInputSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    parishId: idSchema,
});
/**
 * 본당 검색 입력 스키마
 */
export const searchChurchesInputSchema = z.object({
    parishId: idSchema,
    query: z.string().optional(),
});
